import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/experience_on.svg'


const _withScopeId = n => (_pushScopeId("data-v-c763e55a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "applicant" }
const _hoisted_2 = { class: "fev_text6 fw_700 d-block mb-1 name" }
const _hoisted_3 = {
  key: 0,
  class: "hasChat"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_love_face_shadow_bar = _resolveComponent("love-face-shadow-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.applicant.appUserName), 1),
    _createElementVNode("div", {
      class: "imageContainer",
      style: _normalizeStyle('background-image: url(\'' + _ctx.applicant.imageUrl + '\')')
    }, [
      (_ctx.applicant.chatRoomIdentifier)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_localized_text, {
              localizedKey: "app_ChatAperta",
              text: "Chat aperta",
              class: "fev_text7 fw_700 mt-1 px-2"
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_love_face_shadow_bar, {
        class: "justify-content-center",
        text: _ctx.applicant.affinityPercentage + '%'
      }, null, 8, ["text"])
    ], 4)
  ]))
}